import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProductItems } from '../../../../../../models/product/get-product-request';
import { AppDataService, StoreService } from '../../../../../../services';
import { MessageService } from 'primeng/api';
import { Observable, map, startWith } from 'rxjs';

@Component({
  selector: 'app-availability-tab',
  templateUrl: './availability-tab.component.html',
  styleUrls: ['./availability-tab.component.scss'],
  providers: [MessageService]
})
export class AvailabilityTabComponent implements OnInit {
  @Input() product: ProductItems | null = null;
  @Input() availabilityControl!: FormControl;
  @Input() storeSelectedSet = new Set<any>();
  @Output() availabilityDataChanged = new EventEmitter<any>();
  storeSelectedTemp: any;
  options: any[] = []; // TODO Create StoreLocation model
  filteredOptions!: Observable<any[]>;

  constructor(
    private storeService: StoreService,
    private appData: AppDataService,
    private messageService: MessageService
  ) {}

  // Parameter type any to get the option class and the value selected
  addStoreSelected(store: any) {
    this.storeSelectedSet.add(this.storeSelectedTemp);
    this.availabilityControl.setValue('');
    this.emitAvailabilityData();
  }

  ngOnInit(): void {
    this.getStoresByMerchant();
    // Auto complete filter
    this.filteredOptions = this.availabilityControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filter(value || ''))
    );
    // Initialize with existing product data if available
    this.initializeForm();
  }

  private filter(value: any): string[] {
    const filterValue = value.toString().toLowerCase();

    return this.options.filter((option) =>
      option.Name.toLowerCase().includes(filterValue)
    );
  }

  getStoresByMerchant() {
    const dto = {
      MerchantId: this.appData.authData.MerchantId,
    };

    this.storeService
      .getStoresByMerchant(dto, this.messageService)
      .then((data) => {
        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }
        this.options = data.Items;
      })
      .catch((err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err,
        });
      });
  }

  removeExcludeStore(store: any) {
    this.storeSelectedSet.delete(store);
    this.emitAvailabilityData();
  }

  initializeForm(): void {
    if (this.product && this.product.ExcludedStores) {
      this.storeSelectedSet = new Set(this.product.ExcludedStores);
    }
  }

  emitAvailabilityData(): void {
    const availabilityData = {
      ExcludedStores: Array.from(this.storeSelectedSet),
      ExcludedStoreIds: Array.from(this.storeSelectedSet).map(store => store.Id)
    };
    this.availabilityDataChanged.emit(availabilityData);
  }

  // Method to get current availability data (can be called from parent)
  getCurrentAvailabilityData(): any {
    const availabilityData = {
      ExcludedStores: Array.from(this.storeSelectedSet),
      ExcludedStoreIds: Array.from(this.storeSelectedSet).map(store => store.Id)
    };
    return availabilityData;
  }
}
